import { render, staticRenderFns } from "./overlap_updates_history.vue?vue&type=template&id=7c80904f&scoped=true&"
import script from "./overlap_updates_history.vue?vue&type=script&lang=js&"
export * from "./overlap_updates_history.vue?vue&type=script&lang=js&"
import style0 from "./overlap_updates_history.vue?vue&type=style&index=0&id=7c80904f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c80904f",
  null
  
)

export default component.exports